import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const PathGroupsRemove = connect(state => ({
  messages: state.messages,
  pageState: state.pageState
}))(class extends Component {
  remove = async () => {
    const { groupId, pageState: { path }, updateGroups } = this.props;
    await api.delete(`/admin/paths/${path.id}/groups/${groupId}`);
    await updateGroups({showLoading: false});
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonRemove}
        buttonIcon="trash-alt"
        buttonSize="small"
        buttonText={messages.commonRemoveGroup}
        category="danger"
        confirmText={messages.pathsGroupsRemoveConfirm}
        confirmTitle={messages.commonRemoveGroup}
        onConfirm={this.remove}
        successMessage={messages.commonRemoveGroupSuccess}
        stopPropagation={true}
      />
    );
  }
});

export default PathGroupsRemove;
